import script from "./billingRules.vue?vue&type=script&setup=true&lang=js"
export * from "./billingRules.vue?vue&type=script&setup=true&lang=js"

import "./billingRules.vue?vue&type=style&index=0&id=51f2e4d6&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f2e4d6"]])

export default __exports__